import React from 'react';
import MinigameCenter from '../../components/Minigame/MinigameCenter';
import SportsRight from '../../components/sports/SportsRight';

const Squidgame = () => {
    return (
        <div data-v-623d66c4="" className="contents row" style={{flexDirection: "row"}}>
            <MinigameCenter type="squidgame"/>
            <SportsRight type="minigame"/>
        </div>
    );
};

export default Squidgame;


// WEBPACK FOOTER //
// ./src/containers/minigame/Squidgame.js